export default {
  title: "Табло",
  subtitle: "Пациентски портал",

  // OTP entry page
  entry: {
    errorTitle: "Неуспешно зареждане на визитата",
    timeoutTitle: "Прекалено дълго чакане",
    timeoutSubtitle: "Сесията не може да бъде потвърдена. Моля, опитайте отново.",
    retry: "Повторен опит",
  },

  results: {
    title: "Резултати",
    subtitle: "Лабораторни резултати",
    comingSoon: "Очаквайте скоро",
    description: "Тази функция ще ви позволи да разгледате вашите лабораторни резултати.",

    table: {
      examination: "Изследване",
      flag: "Флаг",
      result: "Резултат",
      units: "Единици",
      refRange: "Реф. граници",
      takenTooltip: "Дата и час на вземане на пробата",
    },

    patient: {
      title: "Пациент",
      name: "Имена",
      dob: "Дата на раждане",
      sex: "Пол",
      male: "Мъж",
      female: "Жена",
      maleShort: "М",
      femaleShort: "Ж",
      identifier: "Идентификатор",
      visit: "Посещение",
      date: "Дата на посещение",
      location: "Локация на регистрация",
      copyVisit: "Копиране на номер на посещение",
      copyPid: "Копиране на идентификатор на пациента",
      copied: "Копирано!",
      pid: "ЕГН",
      tooltipVisitId: "Номер на посещение",
      tooltipVisitDate: "Дата на посещение",
      tooltipCategory: "Категория на посещение",
      tooltipLocation: "Локация на регистрация",
      tooltipRequester: "Заявител",
      tooltipDoctor: "Лекуващ лекар",
      tooltipNotes: "Бележки",
      tooltipSaleSchema: "Схема на продажба",
      tooltipFund: "Отделение / Фонд",
    },

    sections: {
      results: "Резултати",
      samples: "Взети проби",
    },

    sample: {
      barcode: "Баркод",
      taken: "Взета на",
    },

    refresh: {
      tooltip: "Обновяване на резултатите",
    },

    pdf: {
      tooltip: "Изтегляне на PDF",
    },

    email: {
      tooltip: "Изпращане по имейл",
    },

    flagLegend: {
      title: "Обозначения на флаговете",
    },

    colorLegend: {
      title: "Цветова легенда",
    },

    disclaimerTitle: "Медицинска бележка",
    disclaimer:
      "Лабораторните резултати не са диагноза, а основа за нея. Приемането на каквито и да е лекарства без рецепта може да бъде опасно за вашето здраве. Моля, консултирайте се с квалифицирани лекари за интерпретацията на резултатите.",

    error: {
      loadFailed: "Грешка при зареждане на резултатите. Моля, опитайте отново.",
      noResults: "За това посещение няма налични резултати.",
      noResultsTableTitle: "Няма налични резултати",
      noResultsTableSubtitle: "За това посещение все още няма готови резултати.",
      noSamplesTableTitle: "Няма регистрирани проби",
      noSamplesTableSubtitle: "За това посещение не са регистрирани взети проби.",
      retry: "Повторен опит",
      login: "Вход",
      serverTitle: "Нещо се обърка",
      serverSubtitle: "Неуспешно зареждане на резултатите. Моля, опитайте отново.",
      networkTitle: "Загубена връзка",
      networkSubtitle: "Няма връзка със сървъра. Проверете интернет връзката си.",
      timeoutTitle: "Времето за изчакване изтече",
      timeoutSubtitle:
        "Заявката не бе обработена навреме. Вероятно е временен проблем — опитайте отново след малко.",
      authTitle: "Сесията изтече",
      authSubtitle: "Моля, влезте отново, за да продължите.",
      unknownTitle: "Неочаквана грешка",
      unknownSubtitle: "Нещо се обърка. Моля, опитайте по-късно.",
    },

    payment: {
      overdueDialogTitle: "Очакващо плащане",
      overdueDialogSubtitle: "Резултатите ще бъдат достъпни след заплащане",
      overdueDialogText:
        "Вашите лабораторни резултати са готови, но достъпът до тях изисква заплащане на дължимата сума. Моля, обърнете се към рецепция или касата на лабораторията.",
      overdueDialogClose: "Затваряне",
      overdueAlert:
        "Достъпът до резултатите изисква заплащане. Моля, обърнете се към рецепция или касата на лабораторията.",
      overdueTableTitle: "Очакващо плащане",
      overdueTableSubtitle:
        "Вашите лабораторни резултати са готови, но достъпът до тях изисква заплащане на дължимата сума. Моля, обърнете се към рецепция или касата на лабораторията.",
    },
  },

  balance: {
    title: "Баланс",
    subtitle: "Баланс на плащане",

    patient: {
      title: "Пациент",
      visit: "Посещение",
      copyVisit: "Копиране на номера на посещение",
    },

    sale: {
      title: "Продажби",
      label: "Продажба:",
      balance: "Баланс",
      copyId: "Копиране на номера на продажба",
      noSalesTitle: "Няма регистрирани продажби",
      noSalesSubtitle: "За това посещение не са регистрирани продажби.",
    },

    products: {
      title: "Продукти",
      product: "Продукт",
      price: "Цена",
      totalLiabilities: "Общо задължения",
      noProductsTitle: "Няма регистрирани продукти",
      noProductsSubtitle: "За тази продажба не са регистрирани продукти.",
    },

    payments: {
      title: "Плащания",
      date: "Дата на плащане",
      dateTooltip: "Дата и час на плащане",
      type: "Начин на плащане",
      amount: "Сума",
      totalPaid: "Общо платено",
      methods: {
        cash: "В брой",
        card: "Кредитна/Дебитна карта",
        unknown: "Плащане",
      },
      noPaymentsTitle: "Няма извършени плащания",
      noPaymentsSubtitle: "За тази продажба няма регистрирано нито едно плащане.",
    },

    currency: "EUR",

    refresh: {
      tooltip: "Обновяване на баланса",
    },

    error: {
      loadFailed: "Грешка при зареждане на баланса. Моля, опитайте отново.",
      noBalance: "За това посещение няма налична информация за баланс.",
      retry: "Повторен опит",
      login: "Вход",
      serverTitle: "Нещо се обърка",
      serverSubtitle: "Неуспешно зареждане на баланса. Моля, опитайте отново.",
      networkTitle: "Загубена връзка",
      networkSubtitle: "Няма връзка със сървъра. Проверете интернет връзката си.",
      timeoutTitle: "Времето за изчакване изтече",
      timeoutSubtitle:
        "Заявката не бе обработена навреме. Вероятно е временен проблем — опитайте отново след малко.",
      authTitle: "Сесията изтече",
      authSubtitle: "Моля, влезте отново, за да продължите.",
      unknownTitle: "Неочаквана грешка",
      unknownSubtitle: "Нещо се обърка. Моля, опитайте по-късно.",
    },
  },
};
